<template>
  <div>
	  <!-- Map Area Starts -->
	      <section class="map-area section-padding news_section1 section" >
	        <div class="banner-sun">
	            <p class="p1 animate fadeInDown animated news_sun_ziti1" style="animation-duration: 1s; animation-delay: 0.1s; visibility: visible;">新闻中心</p>
	    		  <p class="p2 animate zoomIn animated news_sun_ziti2" style="animation-duration: 1s; animation-delay: 1s; visibility: visible;  color: #E91E63;">NEWS</p>
	    		  <!-- <P class="p3 animate fadeInUp animated news_sun_ziti3" style="animation-duration: 1s; animation-delay: 0.3s; visibility: visible;">烟台拿度智能科技有限公司</P> -->
	        </div>
	      </section>
	  	<!-- Map Area End -->
    <!-- Start blog-posts Area -->
    <section class="blog-posts-area section-padding">
      <div class="container xinwennei912">
        <div class="row" style="margin-top: 100px;">
          <div class="col-lg-8 post-list blog-post-list">
            <div class="single-post">
				<div style="width: 100%;height: 110px;line-height: 60px; border-bottom: 1px solid #cccccc;">
					<h2 class="news_sun_ziti2">{{newsinfo.title}}</h2>
					
					<div class="bottom-meta">
					    <div class="user-details row align-items-center">
					        <div class="comment-wrap col-lg-6 col-sm-6">
					            <ul>
					                <li>• {{newsinfo.date}}</li>
					            </ul>
					        </div>
					        <div style="width: 200px !important;position: absolute; right: 10%; cursor: pointer;">
					            <div style="float: right;">
									<!-- <span style="padding: 0px 10px;"><i class="fa fa-weixin"></i> </span>
									<span style="padding: 0px 10px;"><i class="fa fa-weibo"></i></span> -->
									<span style="font-size:14px;color: #666666;">浏览量：{{newsinfo.visits}}</span>
								</div>
					
					        </div>
					    </div>
					</div>
					
				</div>

              <div class="content-wrap" style="margin-top: 50px;line-height: 30px;">
                <p v-html="newsinfo.content">
					
				</p>


              </div>
             

              <!-- Start nav Area -->
              <section class="nav-area py-5">
                <div class="container">
                  <div class="row justify-content-between">
                    <div class="col-sm-6 nav-left justify-content-start d-flex">
                      <div class="post-details">
							<p></p>
                      </div>
                    </div>
                    <div class="col-sm-6 nav-right justify-content-end d-flex">
                      <div class="post-details">
						<p style="font-size: 14px;color: #666666;">
							<a :href="'/blog?id='+ cid " style="color: black;">
							<span style="background: #ddd; padding: 5px 20px; color: #757575;">返回列表页</span>
							</a>
						</p>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
              <!-- End nav Area -->

             

    


            </div>
          </div>
          <div class="sidebar mt-5 mt-lg-0  bbxs912 buxianshia" >
            <div class="single-widget recent-posts-widget" style="border: 0px;background: #f7f8fc;">
              <h4 class="title">拿度推荐</h4>
              <div class="blog-list ">
                <div  v-for="(item,index) in newslist" :key="index" style="width: 100%; height: 250px; border-bottom: 1px solid #cccccc; font-size: 14px;margin-bottom: 20px;">


					<router-link :to="'/blogDetails?id='+item.id+'&cid='+cid " style="color: #000;" @click.native="reloadPage">
						<div style="width: 100%;"><img :src="newurl + item.ico" style="width: 100%; height: 150px;"/></div>
						<p style=" line-height: 50px;">{{truncatecontent(item.title)}} ...</p>
						<p>• {{item.date}}</p>
					</router-link>
				</div>
                

              </div>
            </div>

           

          </div>
        </div>
      </div>
    </section>
    <!-- End blog-posts Area -->
  </div>
</template>



<script>
import axios from 'axios';
export default {
  data() {
    return {
		
			newslist:[],
			qiyeinfo:[],
			zhandianinfo:[],
			daohanglist:[],
			messtel:'',
			messname:'',
			messtitle:'',
			thisid:'',
			cid:'',
			newsinfo:[],
			newurl:'https://naduapi.jurenkeji.com.cn',
    };
  },
  mounted(){
				this.scrollToTop(780);
				// 获取当前id
				this.thisid = this.$route.query.id;
				this.cid = this.$route.query.cid;

				//公司信息
				axios.postForm('https://naduapi.jurenkeji.com.cn/api.php/cms/company', {
			      appid: 'jurenkeji2024',
			      timestamp: '1722845854',
			      signature: '0eb76b812e96966c380b90c6e7416a26'
				})
				.then(response => {
					// console.log(response.data.data);
					this.qiyeinfo = response.data.data;
			
				})
				.catch(error => {
					console.error('当前网络环境异常!', error);
				});

				//站点信息
				axios.postForm('https://naduapi.jurenkeji.com.cn/api.php/cms/site', {
			      appid: 'jurenkeji2024',
			      timestamp: '1722845854',
			      signature: '0eb76b812e96966c380b90c6e7416a26'
				})
				.then(response => {
					// console.log(response.data.data);
					this.zhandianinfo = response.data.data;
				
				})
				.catch(error => {
					console.error('当前网络环境异常!', error);
				});

				//导航数据
				axios.postForm('https://naduapi.jurenkeji.com.cn/api.php/cms/nav', {
			      appid: 'jurenkeji2024',
			      timestamp: '1722845854',
			      signature: '0eb76b812e96966c380b90c6e7416a26'
				})
				.then(response => {
					// console.log(response.data.data);
					this.daohanglist = response.data.data;
				
				})
				.catch(error => {
					console.error('当前网络环境异常!', error);
				});
				//新闻推荐列表
				axios.postForm('https://naduapi.jurenkeji.com.cn/api.php/list/' + this.cid + '/num/3', {
			      appid: 'jurenkeji2024',
			      timestamp: '1722845854',
			      signature: '0eb76b812e96966c380b90c6e7416a26'
				})
				.then(response => {
					// console.log(response.data.data);
					this.newslist = response.data.data;
				})
				.catch(error => {
					console.error('当前网络环境异常!', error);
				});


				//新闻详情
				axios.postForm('https://naduapi.jurenkeji.com.cn/api.php/content/' + this.thisid , {
			      appid: 'jurenkeji2024',
			      timestamp: '1722845854',
			      signature: '0eb76b812e96966c380b90c6e7416a26'
				})
				.then(response => {
					// console.log(response.data.data);
					this.newsinfo = response.data.data;
				})
				.catch(error => {
					console.error('当前网络环境异常!', error);
				});

				

  },
  methods: {
	reloadPage () {
      // console.log('3333')
            // 如果不是因为导航重复而出现错误，则重新加载页面
      window.location.reload()
    },
// 截取新闻标题字符串至指定长度
truncatecontent(dateStr, length = 20) {
		return dateStr.substring(0, length);
		},
	
	scrollToTop(e) {
      window.scrollTo({
        top: e,
        behavior: 'smooth' // 平滑滚动
      });
    }
   
  }
};
</script>
<style>

</style>





// WEBPACK FOOTER //
// BlogDetails.vue?577f6a69